import { render, staticRenderFns } from "./CategoriesTable.vue?vue&type=template&id=a5833364&scoped=true&"
import script from "./CategoriesTable.vue?vue&type=script&lang=js&"
export * from "./CategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesTable.vue?vue&type=style&index=0&id=a5833364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5833364",
  null
  
)

export default component.exports